import {
  POS_TERMINAL_SET,
  POS_TERMINALS_LIST,
  POS_TERMINAL_LOADING,
} from "./actionTypes";

const initialState = {
  deviceId: null,
  terminal: null, // this device's terminal record
  terminals: [],
  loading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_TERMINAL_LOADING:
      return { ...state, loading: action.payload };
    case POS_TERMINAL_SET:
      return {
        ...state,
        deviceId: action.payload.deviceId || state.deviceId,
        terminal: action.payload.terminal !== undefined ? action.payload.terminal : state.terminal,
      };
    case POS_TERMINALS_LIST:
      return { ...state, terminals: action.payload, loading: false };
    default:
      return state;
  }
}
